/******************************************************************************
 * Copyright (c) 2026 Contributors to the Eclipse Foundation.
 *
 * See the NOTICE file(s) distributed with this work for additional
 * information regarding copyright ownership.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * https://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *****************************************************************************/
import { createRoute } from '../../utils';
export var UserSettingsRoutes;
(function (UserSettingsRoutes) {
    UserSettingsRoutes.ROOT = createRoute(['user-settings']);
    UserSettingsRoutes.MAIN = createRoute([UserSettingsRoutes.ROOT, ':tab']);
    UserSettingsRoutes.PROFILE = createRoute([UserSettingsRoutes.ROOT, 'profile']);
    UserSettingsRoutes.TOKENS = createRoute([UserSettingsRoutes.ROOT, 'tokens']);
    UserSettingsRoutes.TRUSTED_PUBLISHERS = createRoute([UserSettingsRoutes.ROOT, 'trusted-publishers']);
    UserSettingsRoutes.NAMESPACES = createRoute([UserSettingsRoutes.ROOT, 'namespaces']);
    UserSettingsRoutes.NAMESPACE_DETAIL = createRoute([UserSettingsRoutes.ROOT, 'namespaces', ':namespace']);
    UserSettingsRoutes.EXTENSIONS = createRoute([UserSettingsRoutes.ROOT, 'extensions']);
    UserSettingsRoutes.EXTENSION_SETTINGS = createRoute([UserSettingsRoutes.ROOT, 'extensions', ':namespace', ':extension']);
})(UserSettingsRoutes || (UserSettingsRoutes = {}));
//# sourceMappingURL=user-settings-routes.js.map